import { Badge, Tooltip } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RecurringInvoiceStatus } from '@features/recurringInvoices/enums/recurringInvoiceStatus'

import { recurringInvoiceStatusToBadgeColor } from '../../../../../../constants/recurringInvoiceStatusToBadgeColor'
import { getRecurringInvoiceStatusLabel } from '../../../../../../utils/getRecurringInvoiceStatusLabel'

interface RecurringInvoiceStatusProps {
  status: RecurringInvoiceStatus
}

export const RecurringInvoiceStatusFormatter = ({ status }: RecurringInvoiceStatusProps): ReactElement => {
  const { t } = useTranslation()

  const statusTooltip = useMemo(() => getRecurringInvoiceStatusLabel(status, t), [status, t])

  return (
    <Tooltip as="span" label={statusTooltip} placement="top">
      <Badge color={recurringInvoiceStatusToBadgeColor[status]} type="dot" />
    </Tooltip>
  )
}
